var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationIconGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "location-icon",
    title: "location icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.17783 20.9348C1.12375 12.1448 0 11.2427 0 8.01219C0 3.58717 3.58171 0 8 0C12.4183 0 16 3.58717 16 8.01219C16 11.2427 14.8763 12.1448 8.82217 20.9348C8.42488 21.5096 7.57508 21.5095 7.17783 20.9348ZM8 11.3506C9.84096 11.3506 11.3333 9.85596 11.3333 8.01219C11.3333 6.16843 9.84096 4.67378 8 4.67378C6.15904 4.67378 4.66667 6.16843 4.66667 8.01219C4.66667 9.85596 6.15904 11.3506 8 11.3506Z",
    fill: "#55A51C",
    className: "location-icon"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIconGreen);
export default __webpack_public_path__ + "static/media/location-icon-green.92969fcea8408bec283382a1aa43c9cb.svg";
export { ForwardRef as ReactComponent };